import p from './device-order-manage.vue';

export default p;
